import AuthRoute from "./pages/auth/route";
import ConversationRoute from "./pages/supervision/route";
import IARoute from "./pages/ia/route";
import OtherRoute from "./pages/other/route";
import AdministrationRoute from "./pages/administration/route";
import AccountRoute from "./pages/account/route";
export default [
    ///...OtherRoute,
    ...AuthRoute,
    ...ConversationRoute,
    ...IARoute,
    ...OtherRoute,
    ...AdministrationRoute,
    ...AccountRoute
];
